/*
   --------------------------------
   Moebius
   --------------------------------
   + https://github.com/hugochinchilla/moebius-scroll
   + version 0.0b1
   + Copyright 2013/06 Hugo Chinchilla
   + Licensed under the MIT license

   + Documentation: https://github.com/hugochinchilla/moebius-scroll
*/
import { defaults } from './components/moebius/constants';

$.moebius = function (options, callback, element) {
  import('./components/moebius/Moebius').then(({ default: Moebius }) => {
    new Moebius(options, callback, element);
  });
};

$.moebius.defaults = {
  ...defaults,
};

$.fn.moebius = function (options, callback) {
  var args = arguments;
  this.each(function () {
    var instance = $.data(this, 'moebius');
    if (instance) {
      instance._debug('instance exists');
      switch (typeof options) {
        case 'object':
          break;

        case 'string':
          instance._rcvCommand.apply(instance, args);
      }
    } else {
      instance = new $.moebius(options, callback, this);
      $.data(this, 'moebius', instance);
    }
  });

  return this;
};

/*
 * smartscroll: debounced scroll event for jQuery *
 * https://github.com/lukeshumard/smartscroll
 * Based on smartresize by @louis_remi: https://github.com/lrbabe/jquery.smartresize.js *
 * Copyright 2011 Louis-Remi & Luke Shumard * Licensed under the MIT license. *
 */

var event = $.event,
  scrollTimeout;

event.special.smartscroll = {
  setup: function () {
    $(this).bind('scroll', event.special.smartscroll.handler);
  },
  teardown: function () {
    $(this).unbind('scroll', event.special.smartscroll.handler);
  },
  handler: function (event, execAsap) {
    // Save the context
    var context = this,
      args = arguments;

    // set correct event type
    event.type = 'smartscroll';

    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(
      function () {
        $(context).trigger('smartscroll', args);
      },
      execAsap === 'execAsap' ? 0 : 100
    );
  },
};

$.fn.smartscroll = function (fn) {
  return fn
    ? this.bind('smartscroll', fn)
    : this.trigger('smartscroll', ['execAsap']);
};
